import http from '@/utils/http' //引入axios
export const getEmptyRecord = data => http.get('/maintenance-center/api/emptyrecord', {
    params: data
}) //查找清空回收箱数据
export const updataEmptyRecord = data => http.put('/maintenance-center/api/emptyrecord', data) //編輯清空回收箱数据
export const addEmptyRecord = data => http.post('/maintenance-center/api/emptyrecord', data) //添加清空回收箱数据
export const deleteEmptyRecord = data => http.delete('/maintenance-center/api/emptyrecord', {
    params: data
}) //刪除清空回收箱数据
export const exportCord = data => http.get('/maintenance-center/api/emptyrecord/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getEmptyRecord,
    updataEmptyRecord,
    addEmptyRecord,
    deleteEmptyRecord,
    exportCord
    // findBarcode
}